import { c as _c } from "react-compiler-runtime";
import CopilotFullscreenModal from 'chatspot-widget-iframe/CopilotFullscreenModal';
import AsyncTaskDeleteModal from './AsyncTaskDeleteModal';
import AsyncConfirmDeleteCommentModal from 'collaboration-sidebar/components/AsyncConfirmDeleteCommentModal';
import AsyncNotificationSettingsModal from './AsyncNotificationSettingsModal';
import useHasNavCopilot from 'collaboration-sidebar/features/copilot/hooks/useHasNavCopilot';
import EmbeddedCommentPopover from '../features/deepCommenting/EmbeddedCommentPopover';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function Modals(t0) {
  "use memo";

  const $ = _c(22);
  const {
    confirmDeleteCommentModalProps,
    taskDeleteModalProps,
    notificationSettingsModalProps,
    showDeleteCommentModal,
    showTaskDeleteModal,
    showNotificationSettingsModal,
    withoutSidebar,
    isReady,
    IFrameError,
    iframeContainerID
  } = t0;
  const hasNavCopilot = useHasNavCopilot();
  let t1;
  if ($[0] !== IFrameError || $[1] !== confirmDeleteCommentModalProps || $[2] !== isReady || $[3] !== showDeleteCommentModal || $[4] !== withoutSidebar) {
    t1 = showDeleteCommentModal && /*#__PURE__*/_jsx(AsyncConfirmDeleteCommentModal, Object.assign({}, confirmDeleteCommentModalProps, {
      withoutSidebar: withoutSidebar,
      isReady: isReady,
      error: IFrameError
    }));
    $[0] = IFrameError;
    $[1] = confirmDeleteCommentModalProps;
    $[2] = isReady;
    $[3] = showDeleteCommentModal;
    $[4] = withoutSidebar;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== showTaskDeleteModal || $[7] !== taskDeleteModalProps) {
    t2 = showTaskDeleteModal && /*#__PURE__*/_jsx(AsyncTaskDeleteModal, Object.assign({}, taskDeleteModalProps));
    $[6] = showTaskDeleteModal;
    $[7] = taskDeleteModalProps;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== notificationSettingsModalProps || $[10] !== showNotificationSettingsModal) {
    t3 = showNotificationSettingsModal && /*#__PURE__*/_jsx(AsyncNotificationSettingsModal, Object.assign({}, notificationSettingsModalProps));
    $[9] = notificationSettingsModalProps;
    $[10] = showNotificationSettingsModal;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== hasNavCopilot) {
    t4 = !hasNavCopilot && /*#__PURE__*/_jsx(CopilotFullscreenModal, {});
    $[12] = hasNavCopilot;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== iframeContainerID) {
    t5 = /*#__PURE__*/_jsx(EmbeddedCommentPopover, {
      iframeContainerID: iframeContainerID
    });
    $[14] = iframeContainerID;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t1 || $[17] !== t2 || $[18] !== t3 || $[19] !== t4 || $[20] !== t5) {
    t6 = /*#__PURE__*/_jsxs(_Fragment, {
      children: [t1, t2, t3, t4, t5]
    });
    $[16] = t1;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
}